<template>
  <b-modal
    id="stockBalanceReportModal"
    ref="stockBalanceReportModal"
    size="xl"
    :title="'ดาวน์โหลดยอดคงเหลือสต๊อก'"
    no-close-on-backdrop
    @close="close"
  >
    <b-form-group label-cols="4" label="ข้อมูล ณ วันที่:" label-align="right">
      <DatePickerField
        v-model="date"
        placeholder="เลือกวันที่ของข้อมูล"
        :is-required="true"
        :is-error="submitted && !date"
        :disabled-date="isFutureDate"
      />
    </b-form-group>

    <template #modal-footer>
      <b-button variant="secondary" @click="close">ยกเลิก</b-button>
      <b-button variant="primary" :disabled="isExporting" @click="handleExport">
        <i class="fas fa-file-download"></i>
        {{ isExporting ? "กำลังดาวน์โหลด " + progress + "%" : "ดาวน์โหลด" }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import DatePickerField from "@/components/table/stock/fields/DatePickerField.vue";

export default {
  name: "StockBalanceReportModal",
  components: { DatePickerField },
  data() {
    return {
      date: null,
      submitted: false,
      isExporting: false,
      progress: 0,
    };
  },
  methods: {
    ...mapActions({
      exportStockBalanceReport: "moduleProductInventory/exportStockBalanceReport",
    }),
    show() {
      this.date = null;
      this.submitted = false;
      this.$bvModal.show("stockBalanceReportModal");
    },
    close() {
      this.$bvModal.hide("stockBalanceReportModal");
    },
    isFutureDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const target = new Date(date);
      target.setHours(0, 0, 0, 0);
      return target > today;
    },
    async handleExport() {
      this.submitted = true;
      // Invalid fields are flagged inline under each field (all at once), so
      // there is no separate toast for them.
      if (!this.date) return;
      this.isExporting = true;
      this.progress = 0;
      try {
        const clinicUrl = this.$route.params.clinicUrl;
        const branchUrl = this.$route.params.branchUrl;
        const date = moment(this.date).format("YYYY-MM-DD");

        const onProgress = fraction => {
          this.progress = Math.round(fraction * 100);
        };

        const blob = await this.exportStockBalanceReport({ clinicUrl, branchUrl, date, onProgress });

        const fileName = `Stock_Balance_Report_${branchUrl}_${date}.csv`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.close();
      } catch (error) {
        console.error("Export stock balance report error:", error);
        this.$emit("error", "เกิดข้อผิดพลาดในการ export รายงานสต๊อก");
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>
